module.exports = __webpack_public_path__ + "img/ceuta.3e3cb24c.png";